import React from 'react';
import _ from 'lodash';

import { ColumnHeaderCell, EditableName, EditableCell, Cell, Column, Table, RowHeaderCell, SelectionModes } from "@blueprintjs/table";
import { ContextMenuTarget, Menu, MenuItem, Divider, Icon } from "@blueprintjs/core";
import convertMinutesToString from '../../Components/convertMinutesToString';

export default class Haltestellen extends React.Component {

    state = {
        haltestellen: []
    }

	cell_onChange = (value, rowIndex, columnIndex) => {
		this.props.changeTime(value, rowIndex, columnIndex-1)
	}

	cell_onConfirm = (value, rowIndex, columnIndex) => {
		this.props.changeTimeConfirm(value, rowIndex, columnIndex-1)
	}

    addZeitraum = (key, columnIndex, row, item, remove) => {
        this.props.addZeitraum(key, columnIndex, row, item, remove)
    }

	getValue = (columnIndex, rowIndex) => {

		if(rowIndex >= this.props.rows.length) {
			return ""
		}
        if(this.props.rows[rowIndex]["slot"+(columnIndex-1)] === undefined) {
            return {}
        }

        var slotName = "slot"+(columnIndex-1)
        var value = this.props.rows[rowIndex][slotName]
		return value
	}

	contextMenu = (val) => {


		var column = val.target.cols[0]
        var row = val.target.rows[0]

        var value = this.getValue(column, row)
        var valueRight = this.getValue(column+1, row)
        if(!value.hasOwnProperty("type")) {
            value = {
                type: ""
            }
        }
        if(!value.type) {
            value.type = valueRight.type
        }

        var textAppend = ""
        if(val.selectedRegions && val.selectedRegions[0].rows[0] !== val.selectedRegions[0].rows[1]) {
            textAppend = <i> (Zeile {(val.selectedRegions[0].rows[0]+1)} bis {(val.selectedRegions[0].rows[1]+1)})</i>
        }

        var menuItems = []

        if(value.umlaufplan_id) {
            var kuerzel = value.umlaufplan_kuerzel.split(",")
            var ids = value.umlaufplan_id.split(",")
            ids.forEach((id, k) => {
                menuItems.push(<MenuItem onClick={() => this.props.gotoTo("/umlaufplan/"+id, true)} icon="document-open" text={kuerzel[k]} />)
            })
            menuItems.push(<Divider />)
        }

        var valueRegion = this.getValue(column, val.selectedRegions[0].rows[0])
        if(valueRegion.f && val.selectedRegions[0].rows[0] !== val.selectedRegions[0].rows[1]) {
            menuItems.push(<MenuItem onClick={() => this.props.copyFormular(valueRegion.f, val.selectedRegions[0].rows, column-1)} icon="duplicate" text={valueRegion.f + " - Formel kopieren "} />)
            menuItems.push(<Divider />)
        }

        menuItems.push(<MenuItem onClick={() => this.props.duplicateKurs(column-1)} icon="duplicate" text={"Kurs duplizieren"} />)
            menuItems.push(<Divider />)

        if(this.props.zeitraum.length > 0) {
            if(value.zeitraum && value.zeitraum.id) {
                menuItems.push(<MenuItem onClick={() => this.addZeitraum("zeitraum", column-1, row, undefined, true)} icon="trash" text={"Gültigkeit entfernen"} />)
            }  
            this.props.zeitraum.forEach((item) => {
                menuItems.push(<MenuItem onClick={() => this.addZeitraum("zeitraum", column-1, row, item)} icon="time" text={item.name} />)
            })
            menuItems.push(<Divider />)
        }

        if(this.props.verkehrshinweis.length > 0) {
            if(value.verkehrshinweis && value.verkehrshinweis.id) {
                menuItems.push(<MenuItem onClick={() => this.addZeitraum("verkehrshinweis", column-1, row, undefined, true)} icon="trash" text={"Verkehrshinweis entfernen"} />)
                //menuItems.push(<Divider />)
            }  
            this.props.verkehrshinweis.forEach((item) => {
                menuItems.push(<MenuItem onClick={() => this.addZeitraum("verkehrshinweis", column-1, row, item)} text={item.symbol + " " + item.name} />)
            })
            menuItems.push(<Divider />)
        }

        menuItems.push(<MenuItem onClick={() => this.props.showDialog(column-1)} icon="search-around" text="Umlaufplan zuweisen" />)
        
        // linienkursnummer nur spalte 1 (linienkursnummer)
        if(value.type === "bus" && !value.skip) {
            menuItems.push(<MenuItem onClick={() => this.props.skipColumn(column-1, row, true, val.selectedRegions[0].rows)} icon="minus" text={<span>Kein Stopp {textAppend}</span>} />)
        }
        if(value.type === "bus" && value.skip) {
            menuItems.push(<MenuItem onClick={() => this.props.skipColumn(column-1, row, false,  val.selectedRegions[0].rows)} icon="plus" text={<span>Stopp {textAppend}</span>} />)
        }

        if(value.type === "zug" && !value.empty) {
            menuItems.push(<MenuItem onClick={() => this.props.skipColumn(column-1, row, true, val.selectedRegions[0].rows)} icon="minus" text={<span>Kein Stopp {textAppend}</span>} />)
        }
        if(value.type === "zug" && value.empty) {
            menuItems.push(<MenuItem onClick={() => this.props.skipColumn(column-1, row, false,  val.selectedRegions[0].rows)} icon="plus" text={<span>Stopp {textAppend}</span>} />)
        }

        menuItems.push(<Divider />)
        if(value.type === "bus" || !value.type) {
            menuItems.push(<MenuItem onClick={() => this.props.changeType(row, "zug")} icon="exchange" text="Typ: Zug" />)
        }
        if(value.type === "zug") {
            menuItems.push(<MenuItem onClick={() => this.props.changeType(row, "bus")} icon="exchange" text="Typ: Bus" />)
        }
        menuItems.push(<Divider />)
        menuItems.push(<MenuItem onClick={() => this.props.deleteRow(row)} icon="delete" text="Zeile löschen" />)
        menuItems.push(<MenuItem onClick={() => this.props.delteColumn(column-1)} icon="delete" text="Spalte löschen" />)

        return(
            <Menu>
                {menuItems}
            </Menu>
        )

    } 

    componentDidMount() {
        var haltestellen = []
        this.props.rows.forEach((slot) => {
            haltestellen.push(slot.haltestelle)
        })
        this.state.haltestellen = haltestellen
    }
 
    shouldComponentUpdate(nextProps, nextState) {
        var doReturn = false
        if(nextProps.direction !== nextState.direction) {
            doReturn = true
            this.state.direction = nextProps.direction
        }
        if(nextProps.rows !== this.props.rows) {
            doReturn = true
        }
        if(nextProps.cols !== this.props.cols) {
            doReturn = true
        }
        if(doReturn) {
            var haltestellen = []
            var linienkursnummern = []
            nextProps.rows.forEach((slot) => {
                haltestellen.push(slot.haltestelle)
            })
            this.state.haltestellen = haltestellen
        }
        return doReturn
    }

    cellRenderer = (rowIndex, columnIndex) => {

            var {
                rows, cols, kilometer, kurs
            } = this.props

            var { 
                haltestellen
            } = this.state

            var bgColor = (rowIndex%2 ? "#fff" : "#ecf0f1")
            if(rows.length === rowIndex) {
                bgColor = "#fff"
            }

            var value = this.getValue(columnIndex, rowIndex)
            var addStyle = {}
            if(value.type === "zug") {
                bgColor = "#ddd"
                addStyle = {fontStyle:'italic',fontWeight:'bold'}
            }

            if(columnIndex === 0) {
                var _haltestelle = ""
                if(haltestellen[rowIndex] !== undefined) {
                    _haltestelle = haltestellen[rowIndex]
                }
                value = this.getValue(columnIndex+1, rowIndex)
                if(value.type === "zug") {
                    bgColor = "#ddd"
                    addStyle = {fontStyle:'italic',fontWeight:'bold'}
                }
                if(this.props.disabled) {
                    return <Cell style={{...addStyle,backgroundColor: bgColor}}>{_haltestelle}</Cell>
                }
                return (
                    <EditableCell
                        loading={value.isLoading && value.isLoading}
                        style={{...addStyle,backgroundColor: bgColor}}
                        onChange={(value) => this.props.changeHaltestelle(value, rowIndex)}
                        onConfirm={(value) => this.props.changeHaltestelleConfirm(value, rowIndex)}
                        value={_haltestelle}
                        tooltip={"Haltestelle: " + _haltestelle}
                    />
                )
            }

            if(value !== undefined && value.skip && value.type === "bus") {
                return <Cell style={{backgroundColor: bgColor,textAlign: "center"}}>{value.firstSkip || value.lastSkip ? "" : "|"}</Cell>
            }

            if(value !== undefined && value.empty && value.type === "zug") {
                return <Cell style={{backgroundColor: bgColor,textAlign: "center"}}></Cell>
            }
            
            if(value === undefined && value.type === "zug") {
                return <Cell style={{backgroundColor: bgColor,textAlign: "center"}}>{value.firstSkip ? "" : "|"}</Cell>
            }

            if(value.raw === undefined) {
                return <Cell></Cell>
            }

            /*
                onChange={(val) => this.cell_onChange({...value, value: val}, rowIndex, columnIndex)}
                onConfirm={(value) => this.cell_onConfirm({value: value}, rowIndex, columnIndex)}
            */

            var tmpValue = value.value
            if(value.f
                && this.state.focus
                && this.state.focus.col === columnIndex
                && this.state.focus.row === rowIndex
            ) {
                tmpValue = value.f
            }

            if(tmpValue === "" && value.f !== undefined) {
                tmpValue = value.f
            }

            if(this.props.disabled) {
                return <Cell style={{...addStyle, backgroundColor: bgColor, textAlign: "center"}}>{tmpValue}</Cell>
            }
            
            return (
                <EditableCell
                    style={{...addStyle, backgroundColor: bgColor, textAlign: "center"}}
                    onChange={(val) => this.cell_onChange({...value, value: val}, rowIndex, columnIndex)}
                    onConfirm={(val) => this.cell_onConfirm({...value, value: val}, rowIndex, columnIndex)}
                    value={tmpValue}
                    tooltip={value.f ? value.f : value.value}
                />
            )
        }

    onFocusedCell = (data) => {
        //this.setState({focus: data})
        this.state.focus = data
        return data
    }

    onKeyDown = (a,b,c) => {
        //console.log("onKeyDown", a,b,c)
    }

	render() {

		var {
			rows, cols, kurs, kilometer, disabled
		} = this.props

        var { 
            haltestellen
        } = this.state

        const renderColumnHeader = (columnIndex) => {
        	/*const nameRenderer = (name) => (
        		<EditableName
                    className="text-center"
        			style={{textAlign: "center"}}
                    name={name}
                    onChange={(value) => this.props.handleChangeHeader(columnIndex-1, value)}
                    onConfirm={(value) => this.props.handleConfirmHeader(columnIndex-1, value)}
                />
            )
            var name = kurs[columnIndex-1]*/
            return <ColumnHeaderCell 
                enableColumnReordering={true}
                style={{textAlign: "center"}}
                name={""}
            />
        }

        const renderRowHeader = (row) => {
            var type = ""
            var name = row+1
            if(this.props.rows[row] !== undefined) {
                type = this.props.rows[row].type
                if(type !== "bus") {
                    name = <Icon icon="train" />
                }
            }
            return <RowHeaderCell 
                name={name}
            />
        }

        const kilometer_renderColumnHeader = () => {
            return <ColumnHeaderCell />
        }

        const kilometer_cellRenderer = (columnIndex) => {
            const nameRenderer = (name) => (
                <EditableName
                    className="text-center kilometerSmall"
                    style={{textAlign: "center", fontSize: "10px"}}
                    name={name === 0 ? "" : name}
                    onChange={(value) => this.props.changeKilometer(value, columnIndex)}
                    onConfirm={(value) => this.props.changeKilometerConfirm(value, columnIndex)}
                />
            )
            return <ColumnHeaderCell
                style={{textAlign: "center"}}
                name={isNaN(kilometer[columnIndex-1]) ? 0 : kilometer[columnIndex-1] }
                nameRenderer={nameRenderer}
            />
        }


        const info_header_cellRenderer = () => {
            return <ColumnHeaderCell
                style={{textAlign: "center"}}
                name={""}
            />
        }

        var umlaufplanRows = 0
        var umlaufplan = {}
        cols.forEach((col, idx) => {

            if(this.props.rows === undefined || this.props.rows.length === 0) {
                return
            }

            var value = this.props.rows[0]["slot"+idx]
            if(value === undefined) {
                return
            }

            if(!value.umlaufplan_id) {
                return
            }

            if(!value.umlaufplan_color) {
                value.umlaufplan_color = ""
            }

            if(!value.umlaufplan_kuerzel) {
                value.umlaufplan_kuerzel = ""
            }

            var colors = value.umlaufplan_color.split(",")
            var kuerzel = value.umlaufplan_kuerzel.split(",")
            var ids = value.umlaufplan_id.split(",")

            var _timesort = value.umlaufplan_timesort.split(",")
            var timesort = value.umlaufplan_timesort.split(",")

            if(umlaufplanRows < colors.length) {
                umlaufplanRows = colors.length
            }

            umlaufplan[idx] = []
            ids.forEach((f,secIdx) => {
                umlaufplan[idx].push({
                    color: colors[secIdx],
                    kuerzel: kuerzel[secIdx],
                    ids: ids[secIdx]
                })
            })
        })

        var infoColumns = [
            "Gültigkeit",
            "Verkehrshinweis",
            "Linienkursnummer",
            "Kilometer",
            "Umlaufplan"
        ]

        const info_cellRenderer = (rowIndex, columnIndex) => {

            if(columnIndex===0 && infoColumns[rowIndex] !== undefined) {
                return <Cell>{infoColumns[rowIndex]}</Cell> 
            }

            if(rowIndex === 0) {
                var value = this.getValue(columnIndex, rowIndex)
                return <Cell style={{textAlign: "center", fontSize: 11}} tooltip={value.zeitraum && value.zeitraum.name}>{value.zeitraum && value.zeitraum.kuerzel}</Cell>
            }

            if(rowIndex === 1) {
                var value = this.getValue(columnIndex, rowIndex)
                return <Cell style={{textAlign: "center", fontSize: 16}} tooltip={value.verkehrshinweis && value.verkehrshinweis.name}>{value.verkehrshinweis && value.verkehrshinweis.symbol}</Cell>
            }

            if(rowIndex === 2) {
                if(this.props.disabled) {
                    return <Cell style={{textAlign: "center"}}>{kurs[columnIndex-1] === 0 ? "" : kurs[columnIndex-1]}</Cell>
                }
                return <EditableCell
                    style={{textAlign: "center"}}
                    value={kurs[columnIndex-1] === 0 ? "" : kurs[columnIndex-1]}
                    onChange={(value) => this.props.handleChangeHeader(columnIndex-1, value)}
                    onConfirm={(value) => this.props.handleConfirmHeader(columnIndex-1, value)}
                />
            }

            if(rowIndex === 3) {
                var _kilometer = isNaN(kilometer[columnIndex-1]) ? 0 : kilometer[columnIndex-1]
                if(this.props.disabled) {
                    return <Cell style={{textAlign: "center"}}>{kilometer === 0 ? "" : _kilometer}</Cell>
                }
                return <EditableCell
                    style={{textAlign: "center"}}
                    value={_kilometer === 0 ? "" : _kilometer}
                    onChange={(value) => this.props.changeKilometer(value, columnIndex)}
                    onConfirm={(value) => this.props.changeKilometerConfirm(value, columnIndex)}
                />
            }

            if(rowIndex >= 4) {
                var value = umlaufplan[columnIndex-1]
                if(value === undefined || value[rowIndex-4] === undefined) {
                    return <Cell style={{textAlign: "center"}}></Cell>
                }
                return <Cell style={{textAlign: "center", backgroundColor: value[rowIndex-4].color}}>{value[rowIndex-4].kuerzel}</Cell>
            }
            return <Cell />
        }

        var newCols = _.clone(cols)
        /*cols.forEach((col, index) => {
            newCols.splice(index+1, 0, "test")
        })*/

        var widths = new Array(newCols.length+1)
        widths[0] = 250
        for(var i=0;i<widths.length-1;i++) {
            i++;
            if(i==0) continue
            /*if(i%2) {
                widths[i+1] = 30
            }*/
        }

		return (
			<div>
                <Table
                    bodyContextMenuRenderer={!this.props.disabled && this.contextMenu}
                    columnWidths={widths}
                    enableColumnResizing={false}
                    numRows={5+umlaufplanRows}
                    defaultColumnWidth={55}
                    enableGhostCells={true}
                >
                    <Column name={this.props.data.nummer + " - " + this.props.data.name} cellRenderer={info_cellRenderer} />
                    {newCols.map((day) => (
                        <Column
                            name={day}
                            columnHeaderCellRenderer={info_header_cellRenderer}
                            cellRenderer={info_cellRenderer}
                        /> 
                    ))}
                </Table>
				<Table

					bodyContextMenuRenderer={!this.props.disabled && this.contextMenu}
					columnWidths={widths}
					defaultColumnWidth={55}
					numRows={rows.length + 1}

                    onRowsReordered={this.props.onRowsReordered}
                    onColumnsReordered={this.props.onColumnsReordered}
					
					enableRowResizing={false}
					enableFocusedCell={true}

					enableRowHeader={true}
					enableRowReordering={true}

                    enableColumnResizing={false}
					enableColumnReordering

                    rowHeaderCellRenderer={renderRowHeader}
                    onFocusedCell={(data) => this.onFocusedCell(data)}
                    
                    selectionModes={SelectionModes.ROWS_AND_CELLS}

                    enableGhostCells={true}
					numFrozenColumns={0}
                    renderMode={"none"}

				>
					<Column name="Haltestelle" cellRenderer={this.cellRenderer}/>
					{newCols.map((day) => (
						<Column
                            name={day}
                            columnHeaderCellRenderer={renderColumnHeader}
                            cellRenderer={this.cellRenderer}
                        />
					))}
				</Table>
			</div>
		)

	}

}


// WEBPACK FOOTER //
// ./src/Routes/Fahrplan/Haltestellen.js